<template>
  <v-card-title class="pt-5 pb-0 d-flex justify-space-between">
    <span style="width: 85%; word-break: break-word">
      {{ title }}
    </span>

    <v-btn
      icon small
      color="lightGrey"
      @click="close"
    >
      <v-icon class="uikit-icon close" />
    </v-btn>
  </v-card-title>
</template>

<script>
export default {
  name: 'DialogCardTitle',

  props: {
    title: {
      type: String,
      default: null,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
